import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes, { number, bool } from 'prop-types';
import { replaceUnicode } from './utils/util';
import './liveBar.less';
import styles from './liveBar.less';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import Button from '@tencent/dui/lib/components/Button';
import Modal from '@tencent/dui/lib/components/Modal';
import MemberAvator from './memberAvator/liveMemAvator';
import {
    IPlayerEvent,
    LiveRoleType,
    LiveState,
    LiveStateChanged,
    AllowFlipChanged,
    AllowFlipState,
    MemberChanged,
    ClientReady,
    MeetingCodeChanged,
    MeetingInfoChanged,
} from '../LiveConst';
import { AUDIENCEPREV, AUDIENCENEXT } from './img/pageindex';
import * as icons from './img/liveshow';

import PPT_Dropdown from './dropdown';
import LiveGuideDialog from './dialog/live-guide-dialog';
import LiveInviteDialog from './dialog/live-invite-dialog';
import LiveMemberDialog from './dialog/live-member-dialog';
import LiveStartMeetingDialog from './dialog/live-startMeeting-dialog';
import LiveEndMeetingDialog from './dialog/live-endMeeting-dialog';
import LiveJoinMeetingDialog from './dialog/live-joinMeeting-dialog';
import LiveFlipPageTip from './dialog/live-flip-page-tip';
import Clock from './Clock';
import { getCookie } from 'steamer-browserutils';
import { get } from 'lodash';
import axios from 'axios';
import classNames from 'classnames'

export default class LiveBar extends Component {
    constructor(props, context) {
        super(props, context);
        this.liveManager = this.props.liveDelegate;
        this.meetingManager = this.props.meetingDelegate;
        this.state = {
            hideToolBar: false,
            hidePageBtn: false,
            audienceInfo: '',
            isLive: false,
            role: LiveRoleType.None,
            enableLive: this.liveManager && this.liveManager.enableLive || false,
            enableAudio: false,         // 是否允许打开语音
            audioOn: false,        // 语音是否打开
            showJoinSnack: false,   // 显示加入会议snackBar
            isInMeeting: false,    // 语音房间是否已加入
            isMute: false,
        };
        this.timer = null;
        this.willShowInvite = false;
        this.unMount = false;
        this.audioStamp = false;  // 会议语音按钮标记位，避免重复点击
        this.microphoneStamp = false;   // 与会者加入会议时的麦克风状态标记位
        this.containerDom = this.props.dropDownContainer || document.body;
    }

    componentDidMount() {
        //热区：move就触发
        document.addEventListener('mousemove', this.handleMouseMove);
        //ToolBar，enter不消失，leave开始计时
        this.handleMouseMove();
        this.starHiddenTimer(2000);

        if (this.liveManager) {
            // 远程播放状态和UI刷新
            this.liveManager.event.on(MemberChanged,this.updateMember);
            this.liveManager.event.on(LiveStateChanged,this.updateLiveUI);
            this.liveManager.event.on(AllowFlipChanged, this.onAllowFlipChanged);
            this.liveManager.event.on(MeetingCodeChanged, this.onAudienceMeetingCodeChanged);
            this.liveManager.event.on(MeetingInfoChanged, this.onAudienceMeetingInfoChanged);
            if (this.liveManager.allowFlip()) {
                this.onAllowFlipChanged(AllowFlipState.YES);
            }
            this.updateMember();
            this.updateLiveUI();
        }

        if (this.meetingManager) {
            this.meetingManager.registLoginEventCallback(this.handleAudioModuleOnline, this.handleAudioModuleOffline);
            this.meetingManager.registQuitMeetingEventCallback(this.audienceQuitMeeting);
            // 外部打开远程演示时，主讲人直接登录，与会者去拉push信息
            if (this.liveManager.role === LiveRoleType.Master) {
                this.props.eventCallBack(IPlayerEvent.MeetingLogin);
            }
        }
    }

    componentWillUnmount() {
        if (this.timer !== null) {
            clearTimeout(this.timer);
        }
        if (this.changePageTimer !== null) {
            clearTimeout(this.changePageTimer);
        }
        if (this.enterTimer !== null) {
            clearTimeout(this.enterTimer);
        }
        document.removeEventListener('mousemove', this.handleMouseMove);
        // this.guideDropDom && this.guideDropDom.removeEventListener('mousemove', this.handleMouseMove);
        // this.inviteDropDom && this.inviteDropDom.removeEventListener('mousemove', this.handleMouseMove);
        this.guideDropDom && this.guideDropDom.removeEventListener('mouseleave', this.handleMouseLeave);
        this.inviteDropDom && this.inviteDropDom.removeEventListener('mouseleave', this.handleMouseLeave);
        this.guideDropDom && this.guideDropDom.removeEventListener('mouseenter', this.handleMouseEnter);
        this.inviteDropDom && this.inviteDropDom.removeEventListener('mouseenter', this.handleMouseEnter);

        if (this.liveManager) {
            this.liveManager.event.off(MemberChanged, this.updateMember);
            this.liveManager.event.off(LiveStateChanged, this.updateLiveUI);
            this.liveManager.event.off(ClientReady, this.showReadyToLiveShow);
            this.liveManager.event.off(MeetingCodeChanged, this.onAudienceMeetingCodeChanged);
            this.liveManager.event.off(MeetingInfoChanged, this.onAudienceMeetingInfoChanged);
        }

        if (this.meetingManager) {
            let meetingCode = this.meetingManager.audioRoomCode;
            if (meetingCode && parseInt(meetingCode, 10) !== 0) {
                if (this.liveManager.role === LiveRoleType.Master) {
                    this.meetingManager.dissolveMeeting();
                } else {
                    this.meetingManager.quitMeeting();
                }
            }
            this.meetingManager.logoutMeetingSDK();
        }
        
        this.unMount = true;
    }

    showToolBar = () => {
        this.setState({
            hideToolBar: 0,
        });
    }
    showPageBtn = () => {
        this.setState({
            hidePageBtn: 0,
        });
    }
    starHiddenTimer = (interval = 0) => {
        if (this.timer !== null) {
            clearTimeout(this.timer);
        }
        let that = this;
        this.timer = setTimeout(() => {
            // 工具栏上有弹出时，不会自动消失。dropdown关闭后再定时消失。
            if (that.dropDom && that.dropDom.isShown()) {
                return;
            }
            if (that.dropInvite && that.dropInvite.isShown()) {
                return;
            }
            if (that.dropMember && that.dropMember.isShown()) {
                return;
            }
            if (that.dropStartMeeting && that.dropStartMeeting.isShown()) {
                return;
            }
            if (that.dropEndMeeting && that.dropEndMeeting.isShown()) {
                return;
            }
            if (!that.enter && !that.realEnter) {
                that.setState({
                    hideToolBar: 1,
                    hidePageBtn: 1,
                });
            }
        }, interval);
    }

    changePageHiddenTimer = () => {
        if (this.changePageTimer !== null) {
            clearTimeout(this.changePageTimer);
            this.changePageTimer = null;
        }
        let that = this;
        this.changePageTimer = setTimeout(() => {
            that.setState({
                hidePageBtn: 1,
            });
        }, 3000);
    }
    
    handleMouseMove = (e) => {
        this.showPageBtn();
        this.changePageHiddenTimer();
    }

    handleMouseEnter = (e) => {
        this.domBarContainer.style.cursor = 'auto';
        // this.maskContainer.style.cursor = 'auto';
        this.realEnter = true;
        this.enterTimer = setTimeout(() => {
            this.showPageBtn();
            this.showToolBar();
            this.enter = true;
        }, 500);
    }
    handleMouseLeave = (e) => {
        this.enter = false;
        this.realEnter = false;
        if (this.enterTimer !== null) {
            clearTimeout(this.enterTimer);
            this.enterTimer = null;
        }
        this.starHiddenTimer();
    }
    handleLastPage = (event) => {
        event.stopPropagation();
        this.props.eventCallBack(IPlayerEvent.Prev, true);
    }

    handleLastPageWithToolbar = (event) => {
        this.handleLastPage(event);
    }

    handleNextPage = (event) => {
        event.stopPropagation();
        this.props.eventCallBack(IPlayerEvent.Next, true);
    }

    handleNextPageWithToolbar = (event) => {
        this.handleNextPage(event);
    }

    setMeetingUsersDocAuth = (policy, padId, meetingId) => {
        const params = {
            obj: {
                id: padId,
                type: 2
            },
            message: '%7B%22seq%22%3A%227e91ac7c-311b-403c-ba51-520c75674fee%22%2C%22action%22%3A1%7D',
            policy: policy === 0 ? 1 : policy,
            prompt: 1,
            opt: 1,
            add: [
                {
                    userID: meetingId,
                    uidSource: 11,
                    roleID: 1,
                }
            ]
        }

        return axios.post(`/v2/privilege/set_user?xsrf=${getCookie('TOK')}`, params);
    }

    handleEndPlay = (event) => {
        event.stopPropagation();
        this.props.eventCallBack(IPlayerEvent.Exit, true);
    }


    getMeetingEnv = () => {
        const envName = getCookie('env_name');
        if (!envName || /^release/.test(envName)) {
            return 'release';
        } else if (/prerelease/.test(envName)) {
            return 'prerelease';
        }
        return 'test';
    }

    getMeetingParams = () => {
        const meetingEnv = this.getMeetingEnv();
        const meetingParamsMap = {
            test: {
                sdkId: '16282553643',
                corpId: '200008554',
            },
            prerelease: {
                sdkId: '16310196082',
                corpId: '1400212767',
            },
            release: {
                sdkId: '16272901304',
                corpId: '1400115281',
            },
        };
        return meetingParamsMap[meetingEnv];
    }

    handleFullscreen = (event) => {
        event.stopPropagation();
        // this.fullScreenTag = true;
        this.props.eventCallBack(IPlayerEvent.FullScreen, true);
    }

    handleToggleLaser = (e) => {
        e.stopPropagation();
        this.props.eventCallBack(IPlayerEvent.Laser);
    }
    onClickLiveShow = (e) => {
        e.stopPropagation();
        this.dropDom.show();
        this.starHiddenTimer();
        this.props.eventCallBack(IPlayerEvent.ShowLiveDialog, true);
    };
    onClickInvite = (e) => {
        e.stopPropagation();
        this.dropInvite.show();
        this.starHiddenTimer();
        this.props.eventCallBack(IPlayerEvent.ShowInvite, true);
    };

    onClickLiveMember = () => {
        this.dropMember.show();
        this.starHiddenTimer();
    }

    syncWithMaster = () => {
        this.props.eventCallBack(IPlayerEvent.SyncWithMaster, true);
    }

    updateMember = () => {
        if (this.liveManager.role === LiveRoleType.Master) {
            let memberCount = this.liveManager.memberCount;
            let audienceCount = memberCount > 0 ? memberCount - 1 : 0;
            if (audienceCount > 0) {
                this.setState({
                    audienceInfo: `${audienceCount}人正在观看`,
                });
            } else {
                this.setState({
                    audienceInfo: `等待收看者加入`,
                });
            }
        }
        else if (this.liveManager.role === LiveRoleType.Audience) {
            let name = this.liveManager.masterName;
            name = replaceUnicode(name);
            // let page = this.liveManager.liveInfo.page;
            name = name.length > 4 ? name.substr(0, 4) + '...' : name;
            this.setState({
                audienceInfo: `${name}正在演示`,
            });
        }
        else {
            this.setState({
                audienceInfo: '',
            });
        }

        let m = this.liveManager.memberList;
        let checkList = [];
        m.forEach(member => {
            let stamp = true;
            checkList.forEach(elem => {
                if (elem && elem.uid && elem.uid === member.uid)
                    stamp = false;
            });
            stamp && checkList.push(member);
        });

        this.userLineRef && this.userLineRef.userChange(checkList);
        this.liveMemberList && this.liveMemberList.userChange(checkList);
    }
    updateLiveUI = () => {
        if(this.unMount) { return }
        let state = this.liveManager.liveInfo.state;

        if (state === LiveState.Pause){
            // 切换为暂停状态时，关闭“邀请你加入语音讨论”对话框
            this.dropJoinMeeting && this.dropJoinMeeting.hide();
            this.setState({
                showJoinSnack: false,
            });
        }

        this.setState({
            isLive: state === LiveState.OnAir,
            hasRoom: state === LiveState.OnAir || state === LiveState.Pause,
            role: this.liveManager.role,
        }, _ => {
            //先刷新界面，再显示对话框，因为按钮位置会变。
            if (this.state.isLive) {
                if (this.willShowInvite) {
                    this.willShowInvite = false;
                    setTimeout(() => {
                        this.handleMouseMove();// 晃一下鼠标，避免消失太快
                        this.dropInvite.show();
                        this.props.eventCallBack(IPlayerEvent.ShowInvite, true);
                    }, 50);
                }
                let confid = this.liveManager.liveInfo.confid;
                if (this.liveManager.role === LiveRoleType.Audience && confid && parseInt(confid, 10) > 0) {
                    this.onAudienceMeetingCodeChanged(confid);
                }
            }
        });
    }
    handleCloseLiveInviteDialog = (state) => {
        this.dropInvite.hide();
        switch (state.action) {
            case 'close':
                break;
            case 'play':
                this.liveManager.liveWillBegin();
                break;
            case 'end show':
                this.liveManager.closeShowRoom();
                break;
        }
    }

    // 点击开启直播
    handleOpenDocLive = () => {
        // 创建房间
        this.liveManager.createShow((result) => {
            if (result.error) {
                Modal.confirm({
                    // title: '标题（可以传入自定义组件）',
                    content: '信息未成功拉取，请刷新后重新发起远程演示。',
                    onOk: () => { window.location.reload() },
                    okText: '立即刷新',
                    cancelText: null
                });
            }
            else {
                // this.setState({
                //     hasShowRoom: true,
                // });
                this.liveManager.masterEnter();
                // 显示就绪界面
                this.liveManager.event.on(ClientReady, this.showReadyToLiveShow);
            }
            this.handleCloseLiveGuideDialog();
            // 本地播放转换为远程播放时Check登录
            this.meetingManager && !this.meetingManager.meetingSDKisLogin && this.props.eventCallBack(IPlayerEvent.MeetingLogin);
            this.props.eventCallBack(IPlayerEvent.MeetingSDKLogin);
        });

    }

    /**
     * 显示邀请界面
     */
    showReadyToLiveShow = () => {
        if (this.props.switchLive) {
            //word 中支持本地演示，直接切为线上演示
            this.willShowInvite = true;
            this.liveManager.liveBegin(true);
        } else {
            //PPT中直接采取线上演示开启新组件
            this.dropInvite.show();
        }
        this.props.eventCallBack(IPlayerEvent.StartLiving, true);
    }

    // 关闭PPT直播用户引导
    handleCloseLiveGuideDialog = () => {
        this.dropDom.hide();
    }

    onAllowFlipChanged = (allow) => {
        if (this.liveManager.role !== LiveRoleType.Audience){
            return;
        }
        switch (allow) {
            case AllowFlipState.YES:
                // TODO 判断是否已经显示了3次。
                if (this.props.eventCallBack(IPlayerEvent.NeedNewUserTip)) {
                    this.handleMouseMove();
                    this.flipTip.show();
                }
                break;
            case AllowFlipState.NO:
                break;
            default:
                break;
        }
    }

    handleGuideDropVisibleChange = (visible) => {
        if (visible) {
            if (!this.guideDropDom) {
                this.guideDropDom = findDOMNode(this.dropDom);
            }
        }
        else {
            // 关闭之后，工具栏定时消失
            this.starHiddenTimer();
        }
    }
    handleInviteDropVisibleChange = (visible) => {
        if (visible) {
            if (!this.inviteDropDom) {
                this.inviteDropDom = findDOMNode(this.dropInvite);
            }
        }
        else {
            // 关闭之后，工具栏定时消失
            this.starHiddenTimer();
        }
        this.props.eventCallBack(IPlayerEvent.ShowPopWindow, visible);
    }

    onCopyLink = (url) => {
        this.props.eventCallBack(IPlayerEvent.CopyLink, true, url);
    }

    onFlipChanged = (value) => {
        if (this.liveManager) {
            this.liveManager.setAllowFlip(value);
            this.props.eventCallBack(IPlayerEvent.AudienceFlip, value);   
        }
    }

    // MeetingSDK登录成功回掉
    handleAudioModuleOnline = (flag, data) => {
        if (flag) {
            this.setState({
                enableAudio: true,
            });
            if (this.liveManager.role === LiveRoleType.Audience) {
                // 与会者登陆成功后主动拉meetingCode并走登录
                this.audienceJoinMeeting(this.microphoneStamp);
            }
        } else {
            Snackbar.show({
                message: '语音模块加载失败',
                duration: 3000,
                containerDom: this.containerDom,
            });
        }
    }

    // MeetingSDK离线回调
    handleAudioModuleOffline = (flag, data) => {
        if (flag) {     // 主动退出or被踢
            this.setState({
                enableAudio: false,
                isInMeeting: false,
                audioOn: false,
            });
            //TODO：解散语音
        } else {
            // TODO：断网提示，重连会自动走
        }
    }

    // 主持人创建/解散会议
    handleAudioStateChanged = (e) => {
        if (this.audioStamp) {
            return;
        }
        let { isInMeeting } = this.state;
        // 主持人
        if (this.liveManager.role === LiveRoleType.Master) {
            if (!isInMeeting) {
                this.dropStartMeeting.show();
            } else {
                this.dropEndMeeting.show();
            }
        }
        // 与会者
        else if (this.liveManager.role === LiveRoleType.Audience) {

        }
        else {

        }
    }

    // 创建语音房间
    onCreateAudioRoom = () => {
        this.dropStartMeeting.hide();
        if (!this.meetingManager.isSupportWebRTC()) {
            Snackbar.show({
                message: '暂不支持在此浏览器下使用语音通话',
                duration: 3000,
                containerDom: this.containerDom,
            });
            return;
        }
        this.audioStamp = true;
        let reportTag = new Date().getTime();
        this.meetingManager.createAudioRoom({
            name: '',   //会议信息
        }, (flag, data) => {
            if (flag) {
                    let meetingCode = data.meetingCode;
                    this.meetingManager.joinAudioRoom({
                        meetingCode: meetingCode,
                        videoOn: false,
                        audioOn: true,
                    }, (flag, data) => {
                        if (flag) {
                            this.setState({
                                isInMeeting: true,
                            });
                            Snackbar.show({
                                message: '你已成功开启语音通话',
                                duration: 3000,
                                containerDom: this.containerDom,
                            });
                            this.setMicrophoneState(true);
                            this.liveManager.setMeetingRoomCode(meetingCode.toString());
                        }
                        this.audioStamp = false;
                    });
            } else {
                this.audioStamp = false;
                Snackbar.show({
                    message: '开启语音失败，请稍后再试。',
                    duration: 3000,
                    containerDom: this.containerDom,
                });
            }
            this.props.eventCallBack(IPlayerEvent.CreateMeeting, flag, data, new Date().getTime() - reportTag)
        });
    }

    // 解散语音房间
    onDissloveAudioRoom = () => {
        this.dropEndMeeting.hide();
        this.meetingManager.dissolveMeeting(0, (flag, data) => {
            if (flag) {
                this.setState({
                    isInMeeting: false,
                    audioOn: false,
                });
                this.liveManager.setMeetingRoomCode(null);
            }
            this.audioStamp = false;
            this.props.eventCallBack(IPlayerEvent.DissloveMeeting, flag, data)
        });
    }

    // 与会者收到会议号变更push
    onAudienceMeetingCodeChanged = (m) => {
        let needJoin = m.length && parseInt(m, 10) !== 0;
        let isAlreadyIn = this.meetingManager.audioRoomCode && parseInt(this.meetingManager.audioRoomCode, 10) !== 0;
        let changeChannel = needJoin && isAlreadyIn && m !== this.meetingManager.audioRoomCode;
        if (this.liveManager.role === LiveRoleType.Audience) {
            if (needJoin) {
                if (changeChannel) {    // 容错，避免主持人关闭后再开启语音时，与会者房间退出失败or未收到退出push的边界条件
                    this.meetingManager.quitMeeting(0, (flag, data) => {
                            this.setState({
                                isInMeeting: false,
                                audioOn: false,
                            });
                    });
                    // 加100ms延时，避免该回调在render前触发的情况
                    setTimeout(() => {
                        this.dropJoinMeeting && this.dropJoinMeeting.show();
                    }, 100);
                } else {
                    if (!isAlreadyIn) {
                        setTimeout(() => {
                            this.dropJoinMeeting && this.dropJoinMeeting.show();
                        }, 100);
                    }
                }
            } else {
                if (isAlreadyIn) {
                    this.meetingManager.quitMeeting(0, (flag, data) => {
                        this.audienceQuitMeeting(flag, data);
                    });
                }
                this.dropJoinMeeting && this.dropJoinMeeting.hide();
                this.setState({
                    showJoinSnack: false,
                });
            }
        }
    }

    // 主持人禁言处理
    onMute = (item) => {
        if (this.liveManager && item) {
            this.liveManager.setMeetingMemberMute(item, (isMute) => {
                let userList = this.liveManager.memberList;
                this.setState({
                    memberList: userList,
                },() => {
                    this.updateMember();
                });
                this.props.eventCallBack(IPlayerEvent.Mute, isMute, item);
            })
        }
    }

    onAllMute = (flag) => {
        if (this.liveManager) {
            this.liveManager.setMeetingAllMute(flag);
            this.props.eventCallBack(IPlayerEvent.allMute, flag);
        }
    }

    // 观看者处理收到的禁言信息
    onAudienceMeetingInfoChanged = (data) => {
        // MMLog('onAudienceMeetingInfoChanged' , data);
        let { isInMeeting, audioOn, isMute } = this.state;
        if (!data) return;
        if (!isInMeeting) return;
        if (this.liveManager.role !== LiveRoleType.Audience)    return;

        let newMuteState = data.allMute;
        if (!newMuteState && data.muteList && data.muteList.length > 0) {
            let uid = this.meetingManager && this.meetingManager.UID || null;
            if (!uid.length) return;
            newMuteState = (data.muteList.indexOf(uid) > -1);
        }
        if (newMuteState === isMute) return;

        this.setMicrophoneMute(newMuteState);
    }

    // 点击麦克风状态按钮
    handleMicrophoneStateChanged = (e) => {
        let { audioOn } = this.state;
        this.setMicrophoneState(!audioOn);
        this.props.eventCallBack(IPlayerEvent.Microphone, !audioOn);
    }

    // 开启/关闭麦克风
    setMicrophoneState = (audioOn) => {
        this.meetingManager.turnAudio(audioOn, (flag, isOn) => {
            this.setState({
                audioOn: isOn,
            });
        });
    }

    // 禁言
    setMicrophoneMute = (isMute) => {
        let audioOn = isMute ? false : this.state.audioOn;
        this.meetingManager.turnAudio(audioOn, (flag, isOn) => {
            this.setState({
                isMute: isMute,
            });
        });
    }

    // 会议dialog回调处理
    handleMeetingDialogCallback = (state) => {
        this.dropStartMeeting && this.dropStartMeeting.hide();
        this.dropEndMeeting && this.dropEndMeeting.hide();
        this.dropMember && this.dropMember.hide();
        this.audioStamp = false;

        switch (state.action) {
            case 'close':
                break;
            case 'add-new':
                this.dropInvite.show();
                this.starHiddenTimer();
                this.props.eventCallBack(IPlayerEvent.ShowInvite, true);
                break;
            default:
                break;
        }
    }

    // 加入会议dialog回调
    handleJoinDialogCallback = (state) => {
        this.dropJoinMeeting && this.dropJoinMeeting.hide();
        switch (state.action) {
            case 'close':
                break;
            case 'close-showTip':
                this.setState({
                    showJoinSnack: true,
                });
                break;
            case 'join-Meeting':
                let audioOn = !state.mute || false;
                this.audienceJoinMeeting(audioOn);
                break;
            default:
                break;
        }
    }

    // 与会者入会逻辑
    audienceJoinMeeting = (audioOn) => {
        if (!this.meetingManager.isSupportWebRTC()) {
            Snackbar.show({
                message: '暂不支持在此浏览器下使用语音通话',
                duration: 3000,
                containerDom: this.containerDom,
            });
            return;
        }
        let audioState = audioOn || false;
        let confmsg = this.liveManager.liveInfo.confmsg && JSON.parse(this.liveManager.liveInfo.confmsg);
        let allMute =  confmsg && confmsg.allMute || false;
        if (!this.meetingManager.meetingSDKisLogin) {
            this.microphoneStamp = audioState;  // 暂存麦克风状态
            this.props.eventCallBack(IPlayerEvent.MeetingLogin);
        } else {
            let meetingCode = this.liveManager.liveInfo.confid;
            let reportTag = new Date().getTime();
            this.meetingManager.joinAudioRoom({
                meetingCode: meetingCode,
                videoOn: false,
                audioOn: true, // 入会时先强行打开麦克风
            }, (flag, data) => {
                if (flag) {
                    this.setState({
                        isInMeeting: true,
                        showJoinSnack: false,
                        audioOn: audioState,    // 入会成功后再根据设置判断麦克风开关
                        isMute: allMute,    // isMute优先级大于audioOn
                    });
                    if (allMute) {
                        this.setMicrophoneMute(true);
                    } else {
                        this.setMicrophoneState(audioState);
                    }
                    Snackbar.show({
                        message: '你已成功加入语音通话',
                        duration: 3000,
                        type:'success',
                        containerDom: this.containerDom,
                    });
                    this.microphoneStamp = false;
                } else {
                    Snackbar.show({
                        message: '加入语音失败，请稍后再试。',
                        duration: 3000,
                        containerDom: this.containerDom,
                    });
                }
                this.props.eventCallBack(IPlayerEvent.JoinMeeting, flag, data, new Date().getTime() - reportTag);
            });
        }
    }

    // 与会者退出会议
    audienceQuitMeeting = (flag, data) => {
        if (flag) {
            this.setState({
                isInMeeting: false,
                audioOn: false,
            });
            if (this.liveManager.role === LiveRoleType.Audience) {
                // 关于这里为何延迟500ms
                // 会出现一种情况，即会议进行中，远程演示被主持人直接关闭时，此时不应该有tips
                // 这种场景下callback会先走退出会议，后更新当前演示状态，callback的时序问题暂时无法矫正，因此前端展示时做下延迟处理
                // --bug=74033125 【PPT】【远程演示接入音视频】演示者会议中点击【关闭演示】，演示者退出远程演示，演示者和观看者收到“会议讨论已结束，远程演示会继续进行”
                setTimeout(() => {
                    let liveState = this.liveManager.liveInfo.state;
                    if (liveState === LiveState.OnAir) {
                        Snackbar.show({
                            message: '语音讨论已结束，远程演示会继续进行',
                            duration: 3000,
                            type:'success',
                            containerDom: this.containerDom,
                        });
                    }
                }, 500);
            }
        }
        this.props.eventCallBack(IPlayerEvent.QuitMeeting, flag, data);
    }
    /**
     * 点击备注按钮
     */
    onToggleNote() {
        this.props.eventCallBack(IPlayerEvent.ToggleNote, !this.props.showNote);
    }

    liveBarConfig() {

        const getKeyValue = (config, key, fallback = true) => {
            return get(config, key, fallback);
        }

        const config = {
            showToolBar: getKeyValue(this.props.config, 'showToolBar'),
            showClock: getKeyValue(this.props.config, 'showClock', false),
            // 时钟后的分隔线
            splitLine0: getKeyValue(this.props.config, 'splitLine0', false),
            pageTurnerBtn: getKeyValue(this.props.config, 'pageTurnerBtn'),
            // 翻页工具后的分隔线
            splitLine1: getKeyValue(this.props.config, 'splitLine1'),
            userListBtn: getKeyValue(this.props.config, 'userListBtn'),
            remoteShowBtn: getKeyValue(this.props.config, 'remoteShowBtn'),
            meetingBtn: getKeyValue(this.props.config, 'meetingBtn'),
            // 麦克风按钮后的分隔线
            splitLine2: getKeyValue(this.props.config, 'splitLine2'),
            noteBtn: getKeyValue(this.props.config, 'noteBtn'),
            laserBtn: getKeyValue(this.props.config, 'laserBtn'),
            // 激光笔按钮后的分隔线
            splitLine3: getKeyValue(this.props.config, 'splitLine3'),
            fullScreenBtn: getKeyValue(this.props.config, 'fullScreenBtn'),
            // toggleViewBtn / openPresentViewWinBtn 两者实际上是互斥的
            /** 模式一：切换备注(即演讲者视图)/观众视图 */
            toggleViewBtn: getKeyValue(this.props.config, 'toggleViewBtn', false),
            /** 模式二：打开演讲者视图弹窗 */
            openPresentViewWinBtn: getKeyValue(this.props.config, 'openPresentViewWinBtn', false),
            quitBtn: getKeyValue(this.props.config, 'quitBtn'),
            position: getKeyValue(this.props.config, 'position'),
        };
        return config;
    }

    getPolicyAndIsOwner = () => {
        const playerFrame = document.getElementById('playerFrame');
        const clientVars = (playerFrame ? (playerFrame.contentWindow && playerFrame.contentWindow.clientVars) : window.clientVars) || {};
        const { policy, isOwner } = clientVars;
        return { policy, isOwner };
    }

    render() {
        const { docType } = this.props;
        let pageInfo = '' + (this.props.currentPage + 1) + ' / ' + this.props.pageCount;
        if (this.props.currentPage === this.props.pageCount) {
            pageInfo = '' + this.props.currentPage + ' / ' + this.props.pageCount;
        }
        let { hideToolBar, hidePageBtn, isLive, hasRoom, enableAudio, isInMeeting, audioOn, showJoinSnack, isMute } = this.state;
        let isAudience = this.state.role === LiveRoleType.Audience;
        let asycInfo = this.liveManager && this.liveManager.getAsyncInfo;
        let allowFlip = !isAudience || this.liveManager.allowFlip();
        let asycVisible = asycInfo && asycInfo.length > 0 && this.liveManager.isManulFlipped && allowFlip ? 'visible' : 'hidden';
        var isFull = this.props.isFullScreen || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled;

        const dropDownAligment = this.props.dropDownAligment ?? 'top';

        // 按钮是否启用的配置
        const liveBarCfg = this.liveBarConfig();
        //总开关关闭，则直接开户toolBar隐藏
        if(!liveBarCfg.showToolBar)
        {
            hideToolBar = true;
        }

        let TDuiBtnStyle = {
            display: 'block',
            color: '#FFFFFF',
        };

        let TDuiPageBtnStyle = {
            display: 'block',
            background: 'none',
            color: '#FFFFFF',
            opacity: hidePageBtn ? '0' : '1',
        };

        // 观众工具
        const audienceToolBar = <div className={'lineWrapper ' + styles.lineWrapper}>
            {liveBarCfg.meetingBtn && isLive && showJoinSnack &&
                <Snackbar
                    action="点击加入"
                    onClickAction={() => {
                        this.dropJoinMeeting && this.dropJoinMeeting.show();
                        this.setState({
                            showJoinSnack: false,
                        })
                    }}
                    type="info"
                    visible={showJoinSnack}
                >
                    正在语音讨论中
            </Snackbar>
            }
            {liveBarCfg.userListBtn && isLive &&
                <div id='present-live-member'>
                    <MemberAvator
                        ref={ref => { this.userLineRef = ref }}
                        liveDelegate={this.props.liveDelegate}
                        onShowMenu={this.onClickLiveMember} />
                </div>
            }
            {
                liveBarCfg.noteBtn && this.props.enableNote &&
                <Button id="present-live-note-btn" className={this.props.showNote ? 'btn pressed' : 'btn'} type="plain" style={TDuiBtnStyle} onClick={this.onToggleNote.bind(this)}>
                    <div className={'btnIcon ' + styles.btnIcon}>
                        <img src={icons.NOTE}></img>
                    </div>
                    <div>备注</div>
                </Button>
            }
            {liveBarCfg.meetingBtn && isLive && isInMeeting &&
                <Button className={'btn ' + styles.btn} type="plain" style={TDuiBtnStyle} disabled={isMute} onClick={this.handleMicrophoneStateChanged.bind(this)}>
                    <div className={'btnIcon ' + styles.btnIcon}>
                        <img src={isMute || !audioOn ? icons.MIC_CLOSE : icons.MIC_OPEN}></img>
                    </div>
                    <div>{isMute ? '已被禁言' : '麦克风'}</div>
                </Button>
            }
            {
                liveBarCfg.splitLine2 && <div className={'toolbarLine1 ' + styles.toolbarLine1} />
            }
        </div>

        // 演示者工具
        const masterToolBar = <div className={'lineWrapper ' + styles.lineWrapper}>
            {
                liveBarCfg.userListBtn && isLive &&
                <div id='present-live-member'>
                    <MemberAvator
                        ref={ref => { this.userLineRef = ref }}
                        liveDelegate={this.props.liveDelegate}
                        onShowMenu={this.onClickLiveMember} />
                </div>
            }
            {
                liveBarCfg.remoteShowBtn && this.state.enableLive && !isLive && (
                    hasRoom ?
                        <Button id="present-live-invite-btn" className={'btn ' + styles.btn} type="plain" style={TDuiBtnStyle} onClick={this.onClickInvite}>
                            <div className={'btnIcon ' + styles.btnIcon}>
                                <img src={icons.LIVE_HIGHLIGHT}></img>
                            </div>
                            <div>远程演示</div>
                        </Button>
                        :
                        <Button id="present-live-show-btn" className={'btn ' + styles.btn} type="plain" style={TDuiBtnStyle} onClick={this.onClickLiveShow}>
                            <div className={'btnIcon' + styles.btnIcon}>
                                <img src={icons.LIVE}></img>
                            </div>
                            <div>远程演示</div>
                        </Button>
                )
            }
            {
                liveBarCfg.meetingBtn && isLive && this.liveManager.role === LiveRoleType.Master && enableAudio &&
                <Button id="present-live-meeting-btn" className={'btn ' + styles.btn} type="plain" style={TDuiBtnStyle} onClick={this.handleAudioStateChanged.bind(this)}>
                    <div className={'btnIcon ' + styles.btnIcon}>
                        <img src={isInMeeting ? icons.AUDIO_CLOSE : icons.AUDIO_OPEN}></img>
                    </div>
                    <div>{isInMeeting ? '挂断通话' : '开启通话'}</div>
                </Button>
            }
            {
                liveBarCfg.meetingBtn && isLive && isInMeeting &&
                <Button className={'btn ' + styles.btn} type="plain" style={TDuiBtnStyle} onClick={this.handleMicrophoneStateChanged.bind(this)}>
                    <div className={'btnIcon ' + styles.btnIcon}>
                        <img src={audioOn ? icons.MIC_OPEN : icons.MIC_CLOSE}></img>
                    </div>
                    <div>麦克风</div>
                </Button>
            }
            {
                liveBarCfg.splitLine2 && isLive &&
                <div className={'toolbarLine1 ' + styles.toolbarLine1} />
            }
            {
                liveBarCfg.laserBtn && this.props.enableLaser &&
                <Button className={'btn ' + styles.btn} type="plain" style={TDuiBtnStyle} onClick={this.handleToggleLaser}>
                    <div className={'btnIcon ' + styles.btnIcon}>
                        <img src={this.props.laserTurnOn ? icons.PEN_HIGHLIGHT : icons.PEN}></img>
                    </div>
                    <div>激光笔</div>
                </Button>
            }
            {
                liveBarCfg.splitLine3 && this.props.enableLaser && <div className={'toolbarLine1 ' + styles.toolbarLine1} />
            }
        </div>

        return (
            <div className={'toolbarWrapper ' + styles.toolbarWrapper}
                    ref={(el) => {this.domTools = el}}
            >
                {<div className={'container ' + styles.container}
                    style={liveBarCfg.position === 'right' ? {right: 0} : {left: 0}}
                    ref={(el) => { this.domBarContainer = el }}
                    onMouseEnter={this.handleMouseEnter.bind(this)}
                    onMouseLeave={this.handleMouseLeave.bind(this)}
                >
                    <div className={classNames({
                            presentController: true,
                            [styles.presentController]: true,
                            presentControllerHidden: hideToolBar,
                            [styles.presentControllerHidden]: hideToolBar,

                            ...(this.props.presentControllerClassName ? { [this.props.presentControllerClassName]: true } : undefined)
                        })}
                        style={hideToolBar ? {opacity: 0} : {}}
                        onClick={(e) => { e.stopPropagation(); }}
                        ref={(el) => { this.domToolBar = el }}
                    >
                        {/* 时钟 */}
                        {liveBarCfg.showClock && 
                            <div className={'lineWrapper ' + styles.lineWrapper}>
                                <Clock />
                                {liveBarCfg.splitLine0 && <div className={'toolbarLine1 ' + styles.toolbarLine1} />}
                            </div>
                        }
                        {   
                            liveBarCfg.pageTurnerBtn && this.props.showFlip && 
                            <div className={'lineWrapper ' + styles.lineWrapper}>
                                {allowFlip && <Button id='toolbarBtnLastPage' className={'btnArrow ' + styles.btnArrow} type="plain" style={TDuiBtnStyle} onClick={this.handleLastPageWithToolbar}
                                disabled={!allowFlip}
                                >
                                    <div className={'btnIcon ' + styles.btnIcon}>
                                        <img src={allowFlip && this.props.currentPage !== 0 ?icons.PREV:icons.PREV_DISABLE}></img>
                                    </div>
                                </Button>}
                                <div className={'pageInfoWrapper ' + styles.pageInfoWrapper}>
                                    <div className={'pageInfo ' + styles.pageInfo}>
                                        <span>{pageInfo}</span>
                                    </div>
                                    <div className={'pageTip ' + styles.pageTip}>
                                        <LiveFlipPageTip className={'flipTip ' + styles.flipTip} ref={ref => { this.flipTip = ref }}></LiveFlipPageTip>
                                    </div>
                                </div>
                                {allowFlip && <Button id='toolbarBtnNextPage' className={'btnArrow ' + styles.btnArrow} type="plain" style={TDuiBtnStyle} onClick={this.handleNextPageWithToolbar}
                                    disabled={!allowFlip}
                                >
                                    <div className={'btnIcon ' + styles.btnIcon}>
                                        <img src={allowFlip && this.props.currentPage !== this.props.pageCount ? icons.NEXT : icons.NEXT_DISABLE}></img>
                                    </div>
                                </Button>}
                                {
                                    // 翻页工具右侧分隔线
                                    liveBarCfg.splitLine1 && <div className={'toolbarLine1 ' + styles.toolbarLine1} />
                                }
                            </div>
                        }
                        {
                            isAudience ? audienceToolBar  : masterToolBar
                        }
                        <PPT_Dropdown belongID={'present-live-show-btn'} ref={ref => { this.dropDom = ref }}
                            onVisibleChange={this.handleGuideDropVisibleChange} scrollable={false}
                            aligment={dropDownAligment}
                            center="center"
                            hasShadow={false}
                            // offsetY={-24}
                            isTransparent={true}
                            container={this.props.dropDownContainer}
                        >
                            <LiveGuideDialog
                                handleOpenDocLive={this.handleOpenDocLive}
                                handleCloseLiveGuideDialog={this.handleCloseLiveGuideDialog}
                                {...this.state}></LiveGuideDialog>
                        </PPT_Dropdown>

                        <PPT_Dropdown belongID={'present-live-meeting-btn'} ref={ref => { this.dropStartMeeting = ref }}
                            onVisibleChange={this.handleInviteDropVisibleChange} scrollable={false}
                            disabled={isInMeeting}
                            aligment={dropDownAligment}
                            center="center"
                            hasShadow={false}
                            // offsetX={-105}
                            // offsetY={-24}
                            isTransparent={true}
                            container={this.props.dropDownContainer}
                        >
                            <LiveStartMeetingDialog
                                handleOpenMeeting={this.onCreateAudioRoom}
                                handleCloseDialog={this.handleMeetingDialogCallback}
                                {...this.state}></LiveStartMeetingDialog>
                        </PPT_Dropdown>

                        <PPT_Dropdown belongID={'present-live-meeting-btn'} ref={ref => { this.dropEndMeeting = ref }}
                            onVisibleChange={this.handleInviteDropVisibleChange} scrollable={false}
                            disabled={!isInMeeting}
                            aligment="screenCenter"
                            hasShadow={false}
                            offsetX={-180}
                            offsetY={-120}
                            isTransparent={true}
                            container={this.props.dropDownContainer}
                        >
                            <LiveEndMeetingDialog
                                handleQuitMeeting={this.onDissloveAudioRoom}
                                handleCloseDialog={this.handleMeetingDialogCallback}
                                {...this.state}></LiveEndMeetingDialog>
                        </PPT_Dropdown>

                        <PPT_Dropdown belongID={'present-live-member'} ref={ref => { this.dropJoinMeeting = ref }}
                            onVisibleChange={this.handleInviteDropVisibleChange} scrollable={false}
                            aligment="screenCenter"
                            hasShadow={false}
                            offsetX={-160}
                            offsetY={-210}
                            isTransparent={true}
                            disableBodyClose={true}
                            container={this.props.dropDownContainer}
                        >
                            <LiveJoinMeetingDialog
                                handleCloseDialog={this.handleJoinDialogCallback}
                                {...this.state}></LiveJoinMeetingDialog>
                        </PPT_Dropdown>

                        <PPT_Dropdown belongID={ isLive ? 'present-live-member' : 'present-live-invite-btn'} ref={ref => { this.dropInvite = ref }}
                            onVisibleChange={this.handleInviteDropVisibleChange} scrollable={false}
                            aligment="screenCenter"
                            hasShadow={false}
                            offsetX={-160}
                            offsetY={-160}
                            isTransparent={true}
                            container={this.props.dropDownContainer}
                        >
                            <LiveInviteDialog
                                handleOpenDocLive={this.handleOpenDocLive}
                                handleCloseDialog={this.handleCloseLiveInviteDialog}
                                hidePlay={isLive}
                                hideClose={true}
                                hideAllowFlip={true}
                                showArrow={false}
                                liveDelegate={this.props.liveDelegate}
                                onCopyLink={this.onCopyLink}
                                onFlipChanged={this.onFlipChanged}
                                {...this.state}></LiveInviteDialog>
                        </PPT_Dropdown>

                        <PPT_Dropdown belongID={'present-live-member'} ref={ref => { this.dropMember = ref }}
                            onVisibleChange={this.handleInviteDropVisibleChange} scrollable={false}
                            aligment={dropDownAligment}
                            center="center"
                            hasShadow={false}
                            // offsetY={-24}
                            isTransparent={true}
                            container={this.props.dropDownContainer}
                        >
                            <LiveMemberDialog
                                ref={ref => { this.liveMemberList = ref }}
                                liveDelegate={this.props.liveDelegate}
                                meetingDelegate={this.props.meetingDelegate}
                                handleCloseDialog={this.handleMeetingDialogCallback}
                                hideMute={isAudience || !isInMeeting}
                                hideAllowFlip={isAudience}
                                onMute={this.onMute}
                                onAllMute={this.onAllMute}
                                onFlipChanged={this.onFlipChanged}
                                {...this.state}></LiveMemberDialog>
                        </PPT_Dropdown>

                        {/* 退出全屏&关闭演示 */}
                        <div className={'lineWrapper ' + styles.lineWrapper}>
                            {
                                liveBarCfg.fullScreenBtn && <Button className={'btn ' + styles.btn} type="plain" style={TDuiBtnStyle} onClick={this.handleFullscreen} >
                                    <div className={'btnIcon ' + styles.btnIcon}>
                                        <img src={isFull ? icons.FULLSCREEN_OUT : icons.FULLSCREEN}></img>
                                    </div>
                                    <div>{isFull ? '退出全屏' : '进入全屏'}</div>
                                </Button>
                            }
                            {liveBarCfg.toggleViewBtn && (!isLive || (isLive && this.state.role === LiveRoleType.Master)) &&
                                <Button className={'btn ' + styles.btn} type="plain" style={TDuiBtnStyle} 
                                    onClick={() => this.props.eventCallBack(IPlayerEvent.ToggleView, true)} 
                                >
                                    <div className={'btnIcon ' + styles.btnIcon}>
                                        <img src={icons.VIEW_SWITCH}></img>
                                    </div>
                                    <div>{!!this.props.isPresenterView ? '观众视图' : '备注视图'}</div>
                                </Button>
                            }
                            {liveBarCfg.openPresentViewWinBtn && (!isLive || (isLive && this.state.role === LiveRoleType.Master)) &&
                                <Button className={'btn ' + styles.btn} type="plain" style={TDuiBtnStyle}
                                    onClick={() => this.props.eventCallBack(IPlayerEvent.OpenPresenterViewWindow, true)} 
                                >
                                    <div className={'btnIcon ' + styles.btnIcon}>
                                        <img style={{ width: 22 }} src={icons.notePage}></img>
                                    </div>
                                    <div>备注视图</div>
                                </Button>
                            }
                            {liveBarCfg.quitBtn && (!isLive || (isLive && this.state.role === LiveRoleType.Master)) &&
                                <Button className={'btn ' + styles.btn} type="plain" style={TDuiBtnStyle} onClick={this.handleEndPlay} >
                                    <div className={'btnIcon ' + styles.btnIcon}>
                                        <img src={icons.END_PLAY}></img>
                                    </div>
                                    <div>关闭演示</div>
                                </Button>
                            }
                        </div>
                    </div>
                </div>}
                <div className={'asyncTip ' + styles.asyncTip} style={{ visibility: asycVisible }}
                    onClick={this.syncWithMaster}
                >
                    <span>{asycInfo}</span>
                </div>
                {
                    isAudience && this.props.showFlip && this.liveManager.allowFlip() &&
                    <button className={'pagebtn ' + styles.pagebtn + ' ' + 'pagePrev ' + styles.pagePrev} style={TDuiPageBtnStyle}  onClick={this.handleLastPage} >
                        <div className={styles.btnIcon}>
                            <img src={AUDIENCEPREV}></img>
                        </div>
                    </button>
                }
                {
                    isAudience && this.props.showFlip && this.liveManager.allowFlip() &&
                    <button className={'pagebtn ' + styles.pagebtn + ' ' + 'pageNext ' + styles.pageNext} style={TDuiPageBtnStyle}  onClick={this.handleNextPage} >
                        <div className={styles.btnIcon}>
                            <img src={AUDIENCENEXT}></img>
                        </div>
                    </button>
                }

            </div>
        );
    }
}

LiveBar.propTypes = {
    dropDownContainer: PropTypes.any,
    showFlip: PropTypes.bool,
    currentPage: PropTypes.number,
    pageCount: PropTypes.number,
    enableLaser: PropTypes.bool,
    laserTurnOn: PropTypes.bool,
    isFullScreen: PropTypes.bool,
    liveDelegate: PropTypes.any,
    meetingDelegate: PropTypes.any,
    eventCallBack: PropTypes.func,
    showNote: PropTypes.bool,
    enableNote: PropTypes.bool,
    switchLive: PropTypes.bool,
};

LiveBar.defaultProps = {
    dropDownContainer: document.body,
    showFlip: true,
    currentPage: 0,
    pageCount: 1,
    enableLaser: true,
    laserTurnOn: true,
    isFullScreen: false,
    liveDelegate: null,
    meetingDelegate: null,
    showNote: true,
    enableNote: false,
    eventCallBack: (event, flag, data, extra) => {},
    switchLive: false,
};